import { SecureWarningModal } from './SecureWarningModal';
import React, { useState } from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { getTranslate } from 'react-localize-redux';
import { IconButton, makeStyles } from '@material-ui/core';
import { Typography } from '../../../ui';
import * as selectors from '../../selectors/cookieSelector';
import { connect } from 'react-redux';
import { hasGdprCookieFeatureFlag } from '../../selectors/cookieSelector';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0px'
  },
  link: {
    color: theme.palette.type === 'dark' ? theme.palette.primary.contrastText : '#414142',
    fontSize: '18px',
    textDecoration: 'underline',
    cursor: 'pointer',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  }
}));
type Props = {
  translate: ReturnType<typeof getTranslate>;
  isPaymentWarning?: boolean;
  style?: React.CSSProperties;
} & ReturnType<typeof mapStateToProps>;

const AboutMyDataComponent = ({
  translate,
  isPaymentWarning = false,
  style,
  hasGdprCookieFeatureFlag
}: Props) => {
  const classes = useStyles({});

  const [show, setShow] = useState(false);
  const warningModal = show && (
    <SecureWarningModal
      isPaymentWarning={isPaymentWarning}
      onOkClick={() => {
        setShow(false);
      }}
      translate={translate}
    />
  );

  if (!hasGdprCookieFeatureFlag) {
    return null;
  }
  return (
    <div style={style}>
      {warningModal}
      <Typography className={classes.link} variant="body1" onClick={() => setShow(true)}>
        {translate('About_my_data')}
      </Typography>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    hasGdprCookieFeatureFlag: selectors.hasGdprCookieFeatureFlag(state)
  };
};

export const AboutMyData = connect(mapStateToProps)(AboutMyDataComponent);
